import { COLLECTION_BY_GENRE_SET_GENRE, CollectionByGenreSetGenre } from './types';

export const setGenre = (genre: string): CollectionByGenreSetGenre => {
    return {
        type: COLLECTION_BY_GENRE_SET_GENRE,
        payload: genre
    };
};
